import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "src/components/pages/landing/landingPage";
import AustinInspectionCheckpointsPage from "src/components/pages/configurationDrivenInspections/austinInspectionCheckpointsPage";
import { useAppDispatch } from "src/store/store";
import { getInspectionsByUser } from "src/store/inspectionSlice";
import CompletedInspections from "./pages/inspection/completedInspections";
import ConfigurationDrivenInspections from "./pages/configurationDrivenInspections/configurationDrivenInspections";
import WorkflowExecutor from "./pages/configurationDrivenInspections/WorkflowExecutor";
import CheckpointsPage from "./pages/configurationDrivenInspections/CheckpointsPage";
import InspectionReviewPage from "./pages/configurationDrivenInspections/inspectionReview/InspectionReviewPage";
import BlurReviewPage from "./pages/configurationDrivenInspections/inspectionReview/BlurReviewPage";
import InspectionSubmittedPage from "./pages/configurationDrivenInspections/inspectionReview/InspectionSubmittedPage";
import OverrideCompliancePage from "./pages/configurationDrivenInspections/inspectionReview/OverrideCompliancePage";
import OverrideCountPage from "./pages/configurationDrivenInspections/inspectionReview/OverrideCountPage";
import FixItNowPage from "./pages/configurationDrivenInspections/inspectionReview/FixItNowPage";
import FixItLaterPage from "./pages/configurationDrivenInspections/inspectionReview/FixItLaterPage";
import ResumeDraftPage from "./pages/configurationDrivenInspections/inspectionReview/ResumeDraftPage";
import ResumeConfirmationPage from "./pages/configurationDrivenInspections/inspectionReview/ResumeConfirmationPage";
import ScannerPage from "./pages/classification/ScannerPage";
import ResultsPage from "./pages/classification/ResultsPage";
import AIResearchResultsPage from "./pages/classification/AIResearchResultsPage";
import SdsDataSheetPage from "./pages/classification/SdsDataSheetPage";
import ToteItemsPage from "./pages/toteScan/ToteItemsPage";
import ChooseContainerPage from "./pages/toteScan/ChooseContainerPage";
import ConfirmQuantityPage from "./pages/toteScan/ConfirmQuantityPage";
import AddedToContainerPage from "./pages/toteScan/AddedToContainerPage";
import DonationOverridePage from "./pages/toteScan/DonationOverridePage";
import HelpSupportPage from "./pages/help/HelpSupportPage";
import ReportIssuePage from "./pages/help/ReportIssuePage";

const AuthorizedContent = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getInspectionsByUser());
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/completedInspections" element={<CompletedInspections />} />
      <Route path="/configurationDrivenInspections" element={<ConfigurationDrivenInspections />} />
      <Route path="/configurationDrivenInspections/workflows/:workflowTemplateId/checkpoints" element={<CheckpointsPage />} />
      <Route path="/configurationDrivenInspections/scheduled/:austinInspectionId/checkpoints" element={<AustinInspectionCheckpointsPage />} />
      <Route path="/configurationDrivenInspections/execute" element={<WorkflowExecutor />} />
      <Route path="/configurationDrivenInspections/:inspectionId/review" element={<InspectionReviewPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/blurReview" element={<BlurReviewPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/resume" element={<ResumeDraftPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/resumeConfirm" element={<ResumeConfirmationPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/submitted" element={<InspectionSubmittedPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/override" element={<OverrideCompliancePage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/overrideCount" element={<OverrideCountPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/fixNow" element={<FixItNowPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/fixLater" element={<FixItLaterPage />} />
      <Route path="/classification/scan" element={<ScannerPage />} />
      <Route path="/classification/results" element={<ResultsPage />} />
      <Route path="/classification/aiResults" element={<AIResearchResultsPage />} />
      <Route path="/classification/sdsDataSheet" element={<SdsDataSheetPage />} />
      {/* WADM Tote Scan flow */}
      <Route path="/tote/items" element={<ToteItemsPage />} />
      <Route path="/tote/chooseContainer" element={<ChooseContainerPage />} />
      <Route path="/tote/confirmQuantity" element={<ConfirmQuantityPage />} />
      <Route path="/tote/addedToContainer" element={<AddedToContainerPage />} />
      <Route path="/tote/donationOverride" element={<DonationOverridePage />} />
      <Route path="/help" element={<HelpSupportPage />} />
      <Route path="/help/report" element={<ReportIssuePage />} />
      {/* Catch-all: any unmatched/unavailable path (e.g. the deprecated /templates*) redirects home */}
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
};

export default AuthorizedContent;
